import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const UserManagement = () => {
  return <TMSIframe path="/user" />;
};

export default React.memo(UserManagement);
